var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showMessage)?_c('div',{staticClass:"session-banner",class:{
    'with-sidebar': _vm.hasSidebar,
  }},[_c('span',[_vm._v("\n    Your session will expire in "+_vm._s(_vm.timeDisplay)+", "),_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.LOGIN.apply(null, arguments)}}},[_vm._v("click here to reauthenticate")]),_vm._v(".\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }